<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}
          <v-chip
            :color="statusColor"
            small
          >{{ form.Status }}</v-chip>
        </span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text ref="cardContent">
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <!-- 收受部門、工作內容、預計完成時間、最後提醒時間、工單狀態-緊急 -->
              <v-col cols="12">
                
                <v-textarea
                  v-if="form.ReportContent"
                  v-model="form.ReportContent"
                  label="回報內容"
                  readonly
                  rows="1"
                  auto-grow
                ></v-textarea>
                <v-textarea
                  v-if="form.Status == '收受部門拒絕'"
                  v-model="form.RejectedReason"
                  label="拒絕原因"
                  readonly
                  rows="1"
                  auto-grow
                ></v-textarea>
                <v-textarea
                  v-if="form.Status == '退回預算'"
                  v-model="form.BudgetRejectedReason"
                  label="預算退回原因"
                  readonly
                  rows="1"
                  auto-grow
                ></v-textarea>
                <v-textarea
                  v-if="form.Status == '獎金被退回'"
                  v-model="form.RewardRejectedReason"
                  label="獎金退回原因"
                  readonly
                  rows="1"
                  auto-grow
                ></v-textarea>
                <v-textarea
                  v-if="form.Status == '退回成果'"
                  v-model="form.ResultRejectedReason"
                  label="成果退回原因"
                  readonly
                  rows="1"
                  auto-grow
                ></v-textarea>
                <v-textarea
                  v-if="form.CloseRemark"
                  v-model="form.CloseRemark"
                  label="關閉原因"
                  readonly
                  rows="1"
                  auto-grow
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  :items="departments"
                  item-text="Name"
                  item-value="ID"
                  label="發送部門"
                  readonly
                  v-model="form.InitiatedDepartmentID"
                  :rules="formRules.InitiatedDepartmentID"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  :items="departments"
                  item-text="Name"
                  item-value="ID"
                  label="收受部門"
                  readonly
                  v-model="form.ReceivedDepartmentID"
                  :rules="formRules.ReceivedDepartmentID"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  :items="originalManagerOptions"
                  item-text="Name"
                  item-value="ID"
                  label="原本的負責人"
                  readonly
                  v-model="form.OriginalManagerID"
                  :rules="formRules.OriginalManagerID"
                ></v-autocomplete>

                <v-autocomplete
                  :items="userOptions"
                  item-text="Name"
                  item-value="ID"
                  label="指定執行人員"
                  v-model="form.UserID"
                  :rules="formRules.UserID"
                  :readonly="oriObj!=null&&oriObj.UserID > 0"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.Content"
                  label="工作內容"
                  rows="1"
                  auto-grow
                  readonly
                  :rules="formRules.Content"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  :items="levelOptions"
                  item-text="Name"
                  item-value="Name"
                  label="緊急狀態"
                  readonly
                  v-model="form.EmergencyLevel"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :value="formattedTime"
                  label="工作日期"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :value="formattedAlertTime"
                  label="最後提醒時間"
                  readonly
                ></v-text-field>
                <span>若該工單超過提醒時間仍未被安排，則會往上呈報至總經理❤</span>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          v-if="canApprove || canReviewBudget || canReviewResult || canReviewReward"
          color="white darken-1"
          depressed
          outlined
          text
          @click="reject"
        >拒絕</v-btn>
        <v-btn
          v-if="canApprove"
          color="white darken-1"
          depressed
          outlined
          text
          @click="approve"
        >接受此工單</v-btn>
        <v-btn
          v-if="canClose"
          color="white darken-1"
          depressed
          outlined
          text
          @click="closeOrder"
        >關閉工單</v-btn>
        <v-btn
          v-if="canReviewBudget"
          color="white darken-1"
          depressed
          outlined
          text
          @click="signBudget"
        >批准預算</v-btn>
        <v-btn
          v-if="canReviewReward"
          color="white darken-1"
          depressed
          outlined
          text
          @click="signReward"
        >簽核獎金</v-btn>
        <v-btn
          v-if="canReport"
          color="white darken-1"
          depressed
          outlined
          text
          @click="report"
        >回報</v-btn>
        <v-btn
          v-if="canReviewResult"
          color="white darken-1"
          depressed
          outlined
          text
          @click="submit"
        >確認完成</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import TodoItemAutoComplete from "@/data/todo-item/TodoItemAutoComplete.js";
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    id: {
      type: Number,
      required: true,
      default: -1
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    form: {},
    defaultForm: {
      EmergencyLevel: "一般"
    },
    levelOptions: [{ Name: "一般" }, { Name: "緊急" }]
  }),
  computed: {
    oriObj () {
      if (this.editingIdx >= 0) return this.$store.state.workOrder.list[this.editingIdx]
      return null
    },
    formRules() {
      return {
        Content: [v => !!v || "請輸入工作內容"],
        ReceivedDepartmentID: [v => !!v || "請選擇收受部門"],
        Time: [v => !!v || "請選擇完成時間"],
        AlertTime: [v => !!v || "請選擇提醒時間"],
        OriginalManagerID: [v => !!v || "請選擇原本的負責人"]
      };
    },
    formTitle() {
      return "檢視工單";
    },
    statusColor() {
      if (this.form.Status == "被拒絕") return "red";
      if (this.form.Status == "確認中") return "green";
      if (this.form.Status == "已安排") return "primary";
      return "";
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    editingIdx() {
      return this.$store.state.workOrder.list.findIndex(o => o.ID == this.id);
    },
    canClose() {
      return (this.form.Status == "收受部門拒絕" || this.form.Status == "收受部門確認中" && moment(this.form.AlertTime) < moment()) && this.myLevel > 10;
    },
    canApprove() {
      return (
        this.form.Status == "收受部門確認中" &&
        this.myLevel == 10 &&
        this.myDepartment.ID == this.form.ReceivedDepartmentID
      );
    },
    canReviewBudget () {
      return (
        this.form.Status == "預算審核中" &&
        this.myLevel >= 1000
      );
    },
    canReviewReward () {
      return (
        this.form.Status == "獎金審核中" &&
        this.myLevel >= 1000
      );
    },
    canReport () {
      return (
        (this.form.Status == "進行中" || this.form.Status == "退回成果") &&
        this.me.ID == this.form.UserID
      );
    },
    canReviewResult () {
      return (
        (this.form.Status == "成果審核中" || this.form.Status == "獎金被退回") &&
        this.myLevel == 10 &&
        this.myDepartment.ID == this.form.InitiatedDepartmentID
      );
    },
    formattedTime() {
      return this.form.Time ? moment(this.form.Time).format("LLL") : "";
    },
    formattedAlertTime() {
      return this.form.AlertTime
        ? moment(this.form.AlertTime).format("LLL")
        : "";
    },
    originalManagerOptions() {
      return this.activeUsers.map(o => ({ ID: o.ID, Name: o.Profile.Name }));
    },
    userOptions () {
      if (!this.form.ReceivedDepartmentID) return []
      // 只能指定收受部門的員工
      const findUserDepartmentID = user =>
        (this.userDepartments.find(o => o.UserID == user.ID) || {})
          .DepartmentID;
          
      return this.activeUsers
        .filter(o => findUserDepartmentID(o) == this.form.ReceivedDepartmentID)
        .map(o => ({ ID: o.ID, Name: o.Profile.Name }));
    },
    ...mapGetters([
      "me",
      "myLevel",
      "departments",
      "myDepartment",
      "taskWorkingItems", 
      "userDepartments", 
      "activeUsers"
    ])
  },
  methods: {
    close() {
      this.isShowDialog = false;
    },
    reject() {
      if (this.editingIdx < 0) {
        return alert("發生異常：無法找到編輯物件");
      }
      
      var reason = prompt("請輸入退回原因");
      if (!reason) return alert("請輸入退回原因");
      let promise;
      let newStatus;
      let rejectReasonKey;
      if (this.myLevel >= 1000 && this.form.Status == '獎金審核中') {
        // 拒絕獎金
        rejectReasonKey = "RewardRejectedReason";
        newStatus = "獎金被退回";
      } else if (this.myLevel >= 1000 && this.form.Status == '預算審核中') {
        // 拒絕預算
        rejectReasonKey = "BudgetRejectedReason";
        newStatus = "退回預算";
      } else if (this.myLevel == 10 && this.form.Status == "成果審核中") {
        rejectReasonKey = "ResultRejectedReason";
        newStatus = "退回成果";
      } else if (this.myLevel == 10 && this.form.Status == "收受部門確認中") {
        rejectReasonKey = "RejectedReason";
        newStatus = "收受部門拒絕";
      } else if (this.myLevel == 10 && this.form.Status == "獎金被退回") {
        rejectReasonKey = "ResultRejectedReason";
        newStatus = "退回成果";
      } else {
        return window.alert('程式錯誤#twidd01')
      }

      let payload = {
        ID: this.form.ID,
      };
      payload['reason'] = reason;

      this.isLoading = true;
      this.$services.workOrder
        .reject(this, payload)
        .then(res => {
          this.$set(
            this.$store.state.workOrder.list[this.editingIdx],
            "Status",
            newStatus
          );
          this.$set(
            this.$store.state.workOrder.list[this.editingIdx],
            rejectReasonKey,
            reason
          );
          TodoItemAutoComplete.notifyActionDetected(this, 'workOrder', this.form.ID)
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    approve() {
      if (this.editingIdx < 0) {
        return alert("發生異常：無法找到編輯物件");
      }
      if (!this.form.UserID) return alert('請設定執行人員')

      var newStatus = "已安排"
      // 如果沒有預算，有專案任務，那就是進行中
      if (!this.form.TaskID) newStatus = "進行中"

      this.isLoading = true;
      this.$services.workOrder
        .approve(this, this.form)
        .then(res => {
          this.$set(
            this.$store.state.workOrder.list[this.editingIdx],
            "Status",
            newStatus
          );
          this.$set(
            this.$store.state.workOrder.list[this.editingIdx],
            "UserID",
            this.form.UserID
          );
          TodoItemAutoComplete.notifyActionDetected(this, 'workOrder', this.form.ID)
          this.close();
        })
        .then(()=>{
          if (newStatus == '已安排') {
            this.$store.state.taskWorkingItem.isFetched = false;
            return this.$services.taskWorkingItem
              .prepareData(this)
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    signBudget () {
      if (this.editingIdx < 0) {
        return alert("發生異常：無法找到編輯物件");
      }
      this.isLoading = true;
      this.$services.workOrder
        .signBudget(this, this.form)
        .then(res => {
          this.$set(
            this.$store.state.workOrder.list[this.editingIdx],
            "Status",
            "收受部門確認中"
          );
          TodoItemAutoComplete.notifyActionDetected(this, 'workOrder', this.form.ID)
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    signReward() {
      if (this.editingIdx < 0) {
        return alert("發生異常：無法找到編輯物件");
      }
      this.isLoading = true;
      this.$services.workOrder
        .signReward(this, this.form)
        .then(res => {
          this.$set(
            this.$store.state.workOrder.list[this.editingIdx],
            "Status",
            "獎金發放中"
          );
          TodoItemAutoComplete.notifyActionDetected(this, 'workOrder', this.form.ID)
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    submit () {
      if (this.editingIdx < 0) {
        return alert("發生異常：無法找到編輯物件");
      }
      this.isLoading = true;
      this.$services.workOrder
        .submit(this, this.form)
        .then(res => {
          this.$set(
            this.$store.state.workOrder.list[this.editingIdx],
            "Status",
            "獎金審核中"
          );
          TodoItemAutoComplete.notifyActionDetected(this, 'workOrder', this.form.ID)
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    report () {
      if (this.editingIdx < 0) {
        return alert("發生異常：無法找到編輯物件");
      }
      
      var reportContent = prompt("請輸入訊息回報");
      if (!reportContent) return alert("請輸入訊息回報");
      let promise;
      let newStatus = "成果審核中";

      let payload = {
        ID: this.form.ID,
        reportContent: reportContent
      };

      this.isLoading = true;
      this.$services.workOrder
        .report(this, payload)
        .then(res => {
          this.$set(
            this.$store.state.workOrder.list[this.editingIdx],
            "Status",
            newStatus
          );
          this.$set(
            this.$store.state.workOrder.list[this.editingIdx],
            "ReportContent",
            reportContent
          );
          this.$store.state.workOrder.isReloaded = true;
          TodoItemAutoComplete.notifyActionDetected(this, 'workOrder', this.form.ID)
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    closeOrder() {
      if (this.editingIdx < 0) {
        return alert("發生異常：無法找到編輯物件");
      }
      let reason = prompt("請輸入備註");
      if (!reason) return alert("請輸入備註");
      let payload = {
        ID: this.form.ID,
        CloseRemark: reason
      };

      this.isLoading = true;
      this.$services.workOrder
        .close(this, payload)
        .then(res => {
          this.$set(
            this.$store.state.workOrder.list[this.editingIdx],
            "Status",
            "已關閉"
          );
          this.$set(
            this.$store.state.workOrder.list[this.editingIdx],
            "CloseRemark",
            reason
          );
          TodoItemAutoComplete.notifyActionDetected(this, 'workOrder', this.form.ID)
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetForm() {
      if (!this.value) return;
      if (this.id < 0 || this.editingIdx < 0) {
        this.isLoading = false;
        alert("發生異常：無法找到編輯物件");
        return;
      }
      if (this.$refs.cardContent) {
        this.$nextTick(() => this.$refs.cardContent.scrollTo(0, 0));
      }
      this.form = JSON.parse(
        JSON.stringify(this.$store.state.workOrder.list[this.editingIdx])
      );
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.resetForm();
    this.isLoading = true;
    this.$services.workOrder.prepareData(this).finally(() => {
      this.isLoading = false;
    });
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    }
  }
};
</script>